// extracted by mini-css-extract-plugin
export default {"rootDiv":"style_rootDiv__qhb4d","loadingGif":"style_loadingGif__0vwIA"};